import { SCENES } from '../games/scenes/scenes';
import { termOf } from './media';

type Config = Record<string, unknown> | null | undefined;

export type Word = { term: string; shown: string; label?: string; picture?: boolean; voice?: boolean };

type Item = { say?: string; answer?: string; also?: string[] };
type Row = { label?: string; items?: string[] };

export function wordsFor(kind: string, config: Config): Word[] {
  const out = new Map<string, Word>();
  const add = (text: unknown, picture: boolean, voice: boolean, split = false) => {
    if (typeof text !== 'string') return;
    for (const piece of split ? text.split(',') : [text]) {
      const term = termOf(piece);
      if (!term) continue;
      const had = out.get(term);
      const shown = had && /\p{Extended_Pictographic}/u.test(had.shown) ? had.shown : piece.trim();
      out.set(term, { term, shown, picture: !!had?.picture || picture, voice: !!had?.voice || voice });
    }
  };
  const c = config ?? {};
  const items = (c.items as Item[] | undefined) ?? [];
  const rows = (c.sequences as Row[] | undefined) ?? [];
  const prompts = (c.prompts as { prompt?: string }[] | undefined) ?? [];
  switch (kind) {
    case 'tileMatch':
      for (const i of items) { add(i.say, false, true); add(i.answer, true, false); }
      break;
    case 'supervisorScored':
    case 'timerHold':
      for (const p of prompts) add(p.prompt, false, true);
      for (const i of items) add(i.say, false, true);
      break;
    case 'sequenceTap':
      for (const r of rows) add(r.label, false, true);
      break;
    case 'yesNo':
      for (const i of items) add(i.say, true, true);
      break;
    case 'memoryPairs':
      for (const i of items) { add(i.say, true, true); add(i.answer, true, true); }
      break;
    case 'oddOneOut':
      for (const i of items) add(i.say, true, false, true);
      break;
    case 'sortBins':
      for (const r of rows) { add(r.label, true, false); (r.items ?? []).forEach((t) => add(t, true, true)); }
      break;
    case 'findAll':
      for (const r of rows) { add(r.label, false, true); (r.items ?? []).forEach((t) => add(t, true, false)); }
      break;
    case 'slotOrder':
      for (const r of rows) { add(r.label, false, true); (r.items ?? []).forEach((t) => add(t, true, true)); }
      break;
    case 'taskChain':
      for (const r of rows) (r.items ?? []).forEach((t) => add(t, true, true));
      break;
    case 'labelParts':
      if (typeof c.scene === 'string' && Array.isArray(c.parts)) {
        const scene = SCENES[c.scene];
        for (const id of c.parts as string[]) {
          const part = scene?.parts.find((p) => p.id === id);
          if (part) add(part.label, true, true);
        }
      }
      break;
  }
  return [...out.values()];
}
